import React, { memo } from "react";
import { Box } from "@chakra-ui/react";
import BoardCanvas from "../../StandeClassroom/board/BoardCanvas";
import { TOOLS } from "../../StandeClassroom/board/boardTools";

/**
 * The board, laid over the paper.
 *
 * The classroom's toolbar only means anything if the things it makes have
 * somewhere to go, so the paper gets the same surface underneath it: notes,
 * shapes, text and ink land around the question rather than in it.
 *
 * It floats over the whole working area and lets the paper through. With the
 * cursor selected the layer is transparent to the pointer, so the answer
 * boxes below behave normally; anything already placed keeps its own pointer
 * events, so a note can still be picked up and moved without arming a tool
 * first. Choose any other tool and the layer takes the pointer, because then
 * a press means "put something here".
 */
const PaperBoardLayer = ({ board, tool, shape, colour, readOnly, onToolUsed, onPointerDownCapture }) => (
  <Box
    position="absolute"
    inset="0"
    // Above the question and its answer boxes, which carry their own
    // stacking: underneath them, every press meant for the pen was caught by
    // whatever was on the paper and nothing could be drawn at all.
    zIndex={15}
    pointerEvents={tool === TOOLS.SELECT || readOnly ? "none" : "auto"}
    onPointerDownCapture={onPointerDownCapture}
    sx={{
      // What has been placed stays reachable even while the layer itself is
      // letting the paper through.
      "[data-board-item]": { pointerEvents: "auto" },
    }}
  >
    <BoardCanvas
      board={board}
      tool={tool}
      shape={shape}
      colour={colour}
      readOnly={readOnly}
      // Placing a note or a shape hands the pointer back to the cursor. The
      // paper never passed this on, so a tool stayed armed after one use —
      // and the add handles, which only show under the cursor, never came.
      onToolUsed={onToolUsed}
      bare
    />
  </Box>
);

export default memo(PaperBoardLayer);
